import BaseDropdownButton from 'components/atoms/baseButton/dropdown';
import ThreeDotsIcon from 'components/atoms/icons/threeDotsIcon';
import { makeid } from 'utils/helpers/makeid';
import { type ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePatientActivity } from 'infrastructure/providers/patient-activity-context';

import s from './styles.module.scss';

import type { IKeyNoteData } from 'infrastructure/interfaces';

interface IDropdownItem {
  key: string;
  label: ReactNode;
  className?: string;
  dataCy?: string;
  disabled?: boolean;
  visible?: boolean;
  onClick?: (...args: any) => void;
}

interface IProps {
  onEdit: () => void;
  onShowHistory: () => void;
  onDelete: () => void;
  note: IKeyNoteData;
}

export const ActionsDropdown = ({
  onDelete,
  onShowHistory,
  onEdit,
  note,
}: IProps) => {
  const { t } = useTranslation();
  const { onActivity } = usePatientActivity();

  const dropdownItems: IDropdownItem[] = useMemo(
    () => [
      {
        key: makeid(10),
        label: t('labels.edit'),
        onClick: () => {
          onActivity();
          onEdit();
        },
      },
      {
        key: makeid(10),
        label: (
          <p
            className={s['margin-0']}
            title={!note.updatedBy ? t('messages.keynoteDontHaveHistory') : ''}
          >
            {t('labels.showVersionHistory')}
          </p>
        ),
        onClick: onShowHistory,
        disabled: !note.updatedBy,
      },
      {
        key: makeid(10),
        label: <p className={s.danger}>{t('labels.delete')}</p>,
        onClick: () => {
          onActivity();
          onDelete();
        },
      },
    ],
    [note.updatedBy, onEdit, onShowHistory, onDelete, t],
  );

  return (
    <BaseDropdownButton
      className={s['actions-btn']}
      type="secondary"
      items={dropdownItems}
      icon={<ThreeDotsIcon />}
    />
  );
};
